module.exports = __webpack_public_path__ + "static/media/zoom-open.81512e2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/zoom-open.svg
// module id = 2445
// module chunks = 0